import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=1c9e333c&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=1c9e333c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e333c",
  null
  
)

export default component.exports